import { render, staticRenderFns } from "./MediaReviewAnalyzer.vue?vue&type=template&id=0a57de7f"
import script from "./MediaReviewAnalyzer.vue?vue&type=script&lang=js"
export * from "./MediaReviewAnalyzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports